// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'components/common/Button';
import message from 'antd/lib/message'
// APOLLO
import createEmailTemplate from 'ApolloClient/Mutations/createEmailTemplate';
import emailTemplatesQuery from 'ApolloClient/Queries/emailTemplates';
import { graphql } from 'react-apollo';
// COMPONENTS
import FormModal from 'components/common/FormModal';
import EmailTemplateForm from 'components/forms/EmailTemplateForm';

export class EmailTemplateModal extends React.Component {
  state = {
    visible: false,
    title: '',
    subject: '',
    body: '',
  };
  onCreateEmailTemplate = async () => {
    let params = {
      title: this.state.title,
      subject: this.state.subject,
      body: this.state.body,
    };
    let variables = { params };

    try {
      await this.props.createEmailTemplate({
        variables,
        refetchQueries: [
          {
            query: emailTemplatesQuery,
            variables: {},
          },
        ],
      });
    } catch (err) {
      console.log(err);
    }

    this.onCancel(); // use this.onCancel to close out the modal and reset the form values
  };
  onSubmit = async () => {
    const { title, subject, body } = this.state;
    if (!title) { return message.error('title is required')}
    if (!subject) { return message.error('subject is required')}
    if (!body) { return message.error('body is required')}

    this.onCreateEmailTemplate()
  };

  onToggleModal = () => {
    this.setState({ 
      visible: !this.state.visible, 
    });
  };

  onCancel = () => {
    this.setState({
      visible: false,
      title: '',
      subject: '',
      body: '',
    });
    console.log('onCancel')
  };

  onChange = changedValue => {
    this.setState(changedValue);
  };

  render() {
    return (
      <div>
        <Button style={s.button} onClick={this.onToggleModal}>
          + EMAIL TEMPLATE
        </Button>
        <FormModal
          title="Add an Email Template"
          visible={this.state.visible}
          onSubmit={this.onSubmit}
          onOk={this.onSubmit}
          okText="Submit"
          onCancel={this.onCancel}
          loading={this.state.loading}
          formComponent={(
              <EmailTemplateForm
              onChange={this.onChange}
              title={this.state.title}
              subject={this.state.subject}
              body={this.state.body}
              {...this.props}
            />
          )}
        />
      </div>
    );
  }
}

// STYLE
// ==========================================
const s = {
  button: {
    position: 'absolute',
    right: 0,
  },
};

let options = () => ({
  refetchQueries: [
    {
      query: emailTemplatesQuery,
      variables: {},
    },
  ],
});

// EXPORT
// ==========================================
export default graphql(createEmailTemplate, { name: 'createEmailTemplate', options })(EmailTemplateModal);



// WEBPACK FOOTER //
// ./src/routes/app-studio/EmailTemplatesArea/EmailTemplateModal/index.js